module.exports = __webpack_public_path__ + "img/ndmeme.a1d46c55.webp";